<template>
  <v-container
    fluid
    class="fill-height"
  >
    <!-- sidebar -->
    <sidebar></sidebar> 
    
    <!-- "no selected case" message -->
    <v-row
      v-if="activeCase.index === null"
      class="fill-height"
      align="center"
      justify="center"
    >
      <v-col cols="12" class="">
        <no-case-selected
          class="mx-auto py-5"
          :is-today-schedule="activeCase.filteredList.length > 0"
        ></no-case-selected>
      </v-col>
    </v-row>

    <!-- main container -->
    <v-row
      v-else
      dense
      :class="['fill-height', {'mr-1': $vuetify.breakpoint.mdAndUp }]"
    >
      <!-- Patient profile -->
      <v-col 
        cols="12"
        md="3"
        align-self="center"
        class="px-md-5 p-0"
      >

        <patient-profile color="secondary"></patient-profile>
        <!-- <v-btn v-else icon class="mb-n3"><v-icon>mdi-account-details</v-icon></v-btn> -->
      </v-col>
      
      <!-- Main content -->
      <v-col
        class="fill-height"
        cols="11"
        sm="12"
        md="9"
      >
        
        <!-- buttons -->
        <v-row
          dense
          justify="center"
          align="baseline"
        >
          <div
            v-for="(button, index) in buttons.list"
            style="width:6vw"
            :class="$vuetify.breakpoint.mdAndUp ? 'mx-2' : 'mx-3'"
            :key="index"    
          >
            <!-- buttons -->
            <v-row justify="center">
              <v-btn 
                fab
                depressed
                :class="buttons.active != index ? 'secondary' : ''"
                :color="buttons.active == index ? 'primary' : 'secondary darken-2'"
                :outlined="buttons.active != index"
                :x-small="$vuetify.breakpoint.smAndDown && buttons.active != index"
                :small="$vuetify.breakpoint.mdAndUp && buttons.active != index"
                @click="scrollAt( '#' + button.id )"
              >
                <v-icon>{{ button.icon }}</v-icon>
              </v-btn>
            </v-row>
            <!-- button label -->
            <v-row justify="center">
              <span
                style="white-space: pre;"
                v-show="$vuetify.breakpoint.mdAndUp"
                class="text-center mt-4 nav-label"
              >
                {{ button.name }}
              </span>
            </v-row>
          </div>
        </v-row>
        

        <!-- progress -->
        <v-row justify="center">
          <v-col
            cols="9"
            class="mt-1"
          >
            <progress-bar :value="progress"></progress-bar>
          </v-col>
        </v-row>
        

        <!-- form content -->
        <v-row id="fillable">
          <!-- form container -->
          <v-col
            cols="12"
            id="formContainer"
            class="overflow-y"
            @scroll="scrollListener"
          >
            <!-- forms -->
            <component
              v-for="form in buttons.list"
              :key="form.id"
              class="forms"
              :is="form.component"
              :id="form.id"
              @click:generate-pdf="medicalCertificateHaveRemarks($event)"
            ></component>

            <!-- error messages -->
            <v-row
              align="center"
              justify="center"
              v-if="errorMessages.length"
            >
              <v-col cols="12">
                Please fill up these field⁄s:
                <div
                  v-for="(message, key) in errorMessages"
                  :key="key"
                  class="error--text d-flex align-center pl-3"
                >
                  <v-icon
                    x-small
                    color="error"
                    class="mr-1"
                  >
                    mdi-asterisk
                  </v-icon>
                  {{ message }}
                </div>
              </v-col>
            </v-row>  

            <!-- <ul id="v-for-object" class="demo">
              <li :title="Parent" :content="{{value}}" :key="error-{{index}}" v-for="(value, name, index) in pms_sync_errors">
                {{ value }} {{ name}} {{ index }}
              </li>
            </ul> -->

            <!-- next button -->
            <v-row v-if="consultation.status != 'submitted'" class="mt-10">
              <v-btn
                rounded
                depressed
                class="mx-auto text-none"
                color="primary"
                @click="next()"
              >
                <!-- :disabled="progress < 80" -->
                Next
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- FINALIZE DIALOG -->
    <v-dialog v-model="summaryDialog" max-width="800" style="z-index: 9999;" persistent>
      <v-card tile class="finalize" height="87vh" max-height="600px" style="border-radius: 0px;">
        <!-- header -->
        <v-row align="center" class="pl-8 pr-4">
          <v-col>
            <h3 class="primary--text">Finalize</h3>
          </v-col>
          <v-col>
            <v-btn icon class="float-right" @click="summaryDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>


        <v-card-text class="ma-0 pa-0 overflow-auto" style="height:80%">
          

          <!-- ************************************************************* CASE INFO ************************************************************* -->

          <v-row class="mx-5 mb-5" id="case">
            <v-col cols="12" class="section-title mb-0 pb-0">
              <div class="d-flex align-center">
                <span class="mr-2">Case Information</span>
              </div>
            </v-col>

            <v-col v-if="summary.case_info" cols="12">
              <span class="caption-text">Chief Complaint</span>
              <h1 class="primary--text">{{ summary.case_info.health_concern || 'N&frasl;A' }}</h1>
            </v-col>
            
            <v-col cols="6">
              <span class="caption-text">Category</span>
              <div class="main-text">{{ summary.category || 'N&frasl;A' }}</div>
            </v-col>

            <v-col cols="6" v-if="summary.category == 'Pediatric'">
              <span class="caption-text">Pediatric Category</span>
              <div class="main-text">{{ summary.pediatric_category || 'N&frasl;A' }}</div>
            </v-col>

            <v-col cols="6" v-if="summary.category == 'Others'">
              <span class="caption-text">Case Category Comments</span>
              <div class="main-text">{{ summary.caseCategoryComments || 'N&frasl;A' }}</div>
            </v-col>

            <v-col cols="6">
              <span class="caption-text">Is Seasonal Illness</span>
              <div v-if="isSeasonalIllness == 0" class="main-text">No</div>
              <div v-if="isSeasonalIllness == 1" class="main-text">Yes</div>
            </v-col>

            <v-col cols="12">
              <hr />
            </v-col>

          </v-row>

          <!-- ************************************************************* CASE INFO ************************************************************* -->






          <!-- ************************************************************* PATIENT INFO ************************************************************* -->
          
          <v-row class="ma-5" id="patient">
            <v-col cols="12" class="section-title mb-0 pb-0">Patient Past Medical History</v-col>

            <v-col cols="6">
              <span class="caption-text">Relevant social factors</span>
              <div class="main-text mb-3 pre-wrap">{{ summary.social || 'N&frasl;A' }}</div>

              <span class="caption-text">Dietary status</span>
              <div class="main-text mb-3 pre-wrap">{{ summary.dietary || 'N&frasl;A' }}</div>

              <span class="caption-text">Immunization</span>
              <div class="main-text pre-wrap">{{ summary.immunization || 'N&frasl;A' }}</div>
            </v-col>

            <v-col cols="6">
              <span class="caption-text">Illness&frasl;Injury</span>
              <div class="main-text mb-3 pre-wrap">{{ summary.illnesses || 'N&frasl;A' }}</div>

              <span class="caption-text">Hospitalizations</span>
              <div class="main-text mb-3 pre-wrap">{{ summary.hospitalizations || 'N&frasl;A' }}</div>

              <span class="caption-text">Operations</span>
              <div class="main-text pre-wrap">{{ summary.operations || 'N&frasl;A' }}</div>
            </v-col>

            <v-col cols="12">
              <hr />
            </v-col>

          </v-row> 

          <!-- ************************************************************* PATIENT INFO ************************************************************* -->





          <!-- ************************************************************* REVIEW OF SYSTEMS ************************************************************* -->
          <v-row class="ma-5" id="exam">
            <v-col cols="12" class="section-title mb-0 pb-0">Review of Systems</v-col>

            <v-col cols="6">

              <span class="caption-text">Constitutional</span>
              <div class="main-text mb-3">
                
                <span v-if="store_constitutional_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_constitutional_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>
                      <span v-if="key+1 !== store_constitutional_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>
                    </div>

                  </span>
                </span>

                <small>
                  <p v-if="store_constitutional && store_constitutional_note != ''"><i><strong>Remarks:</strong> {{ store_constitutional_note }}</i></p>
                  <p v-if="!store_constitutional">N/A</p>
                </small>
              </div>

              <span class="caption-text">Head</span>
              <div class="main-text mb-3">
                
                <span v-if="store_head_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_head_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 0">N/A</strong>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>

                      <span v-if="key+1 !== store_head_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>
                    </div>

                  </span>
                </span>

                <small>
                  <p v-if="store_head && store_head_note != ''"><i><strong>Remarks:</strong> {{ store_head_note }}</i></p>
                  <p v-if="!store_head">N/A</p>
                </small>
              </div>

              <span class="caption-text">Eyes</span>
              <div class="main-text mb-3">
                <span v-if="store_eyes_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_eyes_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>

                      <span v-if="key+1 !== store_eyes_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>
                    </div>

                  </span>
                </span>
                <small>
                  <p v-if="store_eyes && store_eyes_note != ''"><i><strong>Remarks:</strong> {{ store_eyes_note }}</i></p>
                  <p v-if="!store_eyes">N/A</p>
                </small>
              </div>

              <span class="caption-text">Nose, Mouth, Throat</span>
              <div class="main-text mb-3">
                <span v-if="store_ears_nose_mouth_throat_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_ears_nose_mouth_throat_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>

                      <span v-if="key+1 !== store_ears_nose_mouth_throat_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>
                    </div>

                  </span>
                </span>
                <small>
                  <p v-if="store_ears_nose_mouth_throat && store_ears_nose_mouth_throat_note != ''"><i><strong>Remarks:</strong> {{ store_ears_nose_mouth_throat_note }}</i></p>
                  <p v-if="!store_ears_nose_mouth_throat">N/A</p>
                </small>
              </div>

              <span class="caption-text">Cardiovascular</span>
              <div class="main-text mb-3">
                <span v-if="store_cardiovascular_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_cardiovascular_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 0">N/A</strong>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>
                      <span v-if="key+1 !== store_cardiovascular_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>

                    </div>

                  </span>
                </span>
                <small>
                  <p v-if="store_cardiovascular && store_cardiovascular_note != ''"><i><strong>Remarks:</strong> {{ store_cardiovascular_note }}</i></p>
                  <p v-if="!store_cardiovascular">N/A</p>
                </small>
              </div>

              <span class="caption-text">Respiratory</span>
              <div class="main-text mb-3">
                <span v-if="store_respiratory_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_respiratory_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 0">N/A</strong>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>
                      <span v-if="key+1 !== store_respiratory_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>
                    </div>

                  </span>
                </span>
                <small>
                  <p v-if="store_respiratory && store_respiratory_note != ''"><i><strong>Remarks:</strong> {{ store_respiratory_note }}</i></p>
                  <p v-if="!store_respiratory">N/A</p>
                </small>
              </div>
            </v-col>

            <v-col cols="6">
              <span class="caption-text">Gastrointestinal</span>
              <div class="main-text mb-3">
                <span v-if="store_gastrointestinal_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_gastrointestinal_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 0">N/A</strong>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>

                      <span v-if="key+1 !== store_gastrointestinal_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>
                    </div>

                  </span>
                </span>
                <small>
                  <p v-if="store_gastrointestinal && store_gastrointestinal_note != ''"><i><strong>Remarks:</strong> {{ store_gastrointestinal_note }}</i></p>
                  <p v-if="!store_gastrointestinal">N/A</p>
                </small>
              </div>

              <span class="caption-text">Genito-urinary</span>
              <div class="main-text mb-3">
                <span v-if="store_genitourinary_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_genitourinary_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 0">N/A</strong>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>

                      <span v-if="key+1 !== store_genitourinary_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>
                    </div>

                  </span>
                </span>
                <small>
                  <p v-if="store_genitourinary && store_genitourinary_note != ''"><i><strong>Remarks:</strong> {{ store_genitourinary_note }}</i></p>
                  <p v-if="!store_genitourinary">N/A</p>
                </small>
              </div>

              <span class="caption-text">Integumentary</span>
              <div class="main-text mb-3">
                <span v-if="store_integumentary_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_integumentary_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 0">N/A</strong>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>

                      <span v-if="key+1 !== store_integumentary_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>
                    </div>

                  </span>
                </span>
                <small>
                  <p v-if="store_integumentary && store_integumentary_note != ''"><i><strong>Remarks:</strong> {{ store_integumentary_note }}</i></p>
                  <p v-if="!store_integumentary">N/A</p>
                </small>
              </div>

              <span class="caption-text">Musculoskeletal</span>
              <div class="main-text mb-3">
                <span v-if="store_musculoskeletal_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_musculoskeletal_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 0">N/A</strong>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>

                      <span v-if="key+1 !== store_musculoskeletal_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>
                    </div>

                  </span>
                </span>
                <small>
                  <p v-if="store_musculoskeletal && store_musculoskeletal_note != ''"><i><strong>Remarks:</strong> {{ store_musculoskeletal_note }}</i></p>
                  <p v-if="!store_musculoskeletal">N/A</p>
                </small>
              </div>

              <span class="caption-text">Neurologic</span>
              <div class="main-text mb-3">
                <span v-if="store_neurologic_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_neurologic_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 0">N/A</strong>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>

                      <span v-if="key+1 !== store_neurologic_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>
                    </div>

                  </span>
                </span>
                <small>
                  <p v-if="store_neurologic && store_neurologic_note != ''"><i><strong>Remarks:</strong> {{ store_neurologic_note }}</i></p>
                  <p v-if="!store_neurologic">N/A</p>
                </small>
              </div>

              <span class="caption-text">Psychiatric Symptoms</span>
              <div class="main-text mb-3">
                <span v-if="store_psychiatric_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_psychiatric_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 0">N/A</strong>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>

                      <span v-if="key+1 !== store_psychiatric_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>
                    </div>

                  </span>
                </span>
                <small>
                  <p v-if="store_psychiatric && store_psychiatric_note != ''"><i><strong>Remarks:</strong> {{ store_psychiatric_note }}</i></p>
                  <p v-if="!store_psychiatric">N/A</p>
                </small>
              </div>

              <span class="caption-text">Hema/Lymph/Immunologic Symptoms</span>
              <div class="main-text mb-3">
                <span v-if="store_hema_lymph_immunologic_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">
                  <span v-for="(item,key) in store_hema_lymph_immunologic_items.filter(item_instance => { if (item_instance.value) return item_instance})" :key="key">
                    
                    <div v-if="item.value != 0">
                      {{ item.name }}
                      <small>
                        <strong v-if="item.value == 0">N/A</strong>
                        <strong v-if="item.value == 1">Yes</strong>
                        <strong v-if="item.value == 2">No</strong>
                      </small>

                      <span v-if="key+1 !== store_hema_lymph_immunologic_items.filter(item_instance => { if (item_instance.value) return item_instance}).length">, </span>
                    </div>
                    
                  </span>
                </span>
                <small>
                  <p v-if="store_hema_lymph_immunologic && store_hema_lymph_immunologic_note != ''"><i><strong>Remarks:</strong> {{ store_hema_lymph_immunologic_note }}</i></p>
                  <p v-if="!store_hema_lymph_immunologic">N/A</p>
                </small>
              </div>
            </v-col>

            <v-col cols="12">
              <hr />
            </v-col>
          </v-row>

          <!-- ************************************************************* REVIEW OF SYSTEMS ************************************************************* -->




          <!-- ************************************************************* DIAGNOSIS ************************************************************* -->
          <v-row class="ma-5" id="diagnosis">
            <v-col cols="12" class="section-title mb-0 pb-0">Diagnosis</v-col>

            <v-col cols="6" v-for="(value, key) in summary.diagnoses.filter(item_instance => { if (item_instance.record_type == 'current') return item_instance})" :key="key">
              <v-card tile outlined class="pa-2 medium-shade">
                <h4>{{ value.code }}</h4>
                <div>{{ value.description }}</div>
                <div><b>Impression: </b>{{ value.impression }}</div>
              </v-card>
            </v-col>

            <v-col cols="12" class="my-0 py-0">
              <div class="py-5" v-if="summary.diagnoses.length < 1">
                <span>No data available</span>
              </div>
            </v-col>

            <v-col cols="12">
              <hr />
            </v-col>
          </v-row>

          <!-- ************************************************************* DIAGNOSIS ************************************************************* -->





          <!-- ************************************************************* MEDICATION ************************************************************* -->
          <v-row class="ma-5" id="medic">
            <v-col cols="12" class="section-title mb-0 pb-0">Medication</v-col>

            <v-col cols="6" v-for="(value, key) in summary.medications.filter(item_instance => { if (item_instance.record_type == 'current') return item_instance})" :key="key">
              <v-card tile outlined class="pa-2 medium-shade">
                <h3>{{ value.brand }}</h3>
                <p>{{ value.generic }}</p>
                <div><b>Strength⁄Preparation: </b>{{ value.strength }}</div>
                <div><b>Quantity: </b>{{ value.quantity }}</div>
                <div>
                  <b>Instruction: </b>
                  <span v-if="typeof value.instruction == 'string'">
                    {{ value.instruction }}
                  </span>
                  <span v-else>
                    Take {{ value.instruction.take.quantity + ' ' + value.instruction.take.label }}&nbsp;
                    every {{ value.instruction.every.quantity + ' ' + value.instruction.every.label }}&nbsp;
                    for {{ value.instruction.for.quantity + ' ' + value.instruction.for.label }}
                  </span>
                </div>
                <!-- <div><b>Comment: </b>{{ value.instruction.comment }}</div> -->
              </v-card>
            </v-col>

            <v-col cols="12" class="my-0 py-0">
              <div class="py-5" v-if="summary.medications.length < 1">
                <span>No data available</span>
              </div>
            </v-col>

            <v-col cols="12">
              <hr />
            </v-col>
          </v-row>

          <!-- ************************************************************* MEDICATION ************************************************************* -->





          <!-- ************************************************************* RECOMMENDATION ************************************************************* -->

          <v-row class="ma-5" id="recommend">
            <v-col cols="12" class="section-title mb-0 pb-0">Recommendation</v-col>

            <div class="table-wrapper px-3">
              <table
                v-if="summary.recommendations.length"
                class="table table-striped table-bordered"
              >

                <thead>
                  <tr class="text-left">
                    <th>Point of Care</th>
                    <th>Time to Treat</th>
                    <th width="55%;">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(value, key) in summary.recommendations.filter(item_instance => { if (item_instance.record_type == 'current') return item_instance})" :key="key">
                    <td>{{ value.point_of_care }}</td>
                    <td>{{ value.time_to_treat }}</td>
                    <td>{{ value.recommended_action }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="py-5" v-else>
                <span>No data available</span>
              </div>
            </div>

            <v-col cols="12">
              <hr />
            </v-col>
          </v-row>

          <!-- ************************************************************* RECOMMENDATION ************************************************************* -->




          <!-- ************************************************************* NOTES ************************************************************* -->
          <v-row class="ma-5" id="note">
            <v-col cols="12" class="section-title mb-0 pb-0">Note</v-col>

            <div class="table-wrapper px-3">
              <table
                v-if="summary.notes"
                class="table table-striped table-bordered"
              >
                
                <thead>
                  <tr class="text-left">
                    <th>Title</th>
                    <th>Note</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(value, key) in summary.notes" :key="key">
                    <td>{{ value.title }}</td>
                    <td style="white-space: pre-line; font-size: 13px;">{{ value.note }}</td>
                  </tr>
                </tbody>

              </table>
              <div class="py-5" v-else>
                <span>No data available</span>
              </div>
            </div>

            <v-col cols="12">
              <hr />
            </v-col>
          </v-row>

          <!-- ************************************************************* NOTES ************************************************************* -->





          <!-- ************************************************************* REQUEST ************************************************************* -->
          <v-row class="ma-5" id="request">
            <v-col cols="12" class="section-title mb-0 pb-0">
              Request<br />
              <small>
                <strong>Recipient:</strong> <span class="primary--text">{{ destination_email }}</span>
              </small>
            </v-col>

            <v-col cols="12">
              <hr />
            </v-col>

            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th align="left">Care Plan</th>
                  <th align="left">Prescription</th>
                  <th align="left">Laboratory Test</th>
                  <th align="left">Medical Certificate</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ plan ? 'Yes' : 'No'}}</td>
                  <td>
                    {{ prescription ? 'Yes' : 'No'}}
                    <u style="color: grey;"><i>{{ medex ? '(Send to MedExpress)' : ''}}</i></u>
                  </td>
                  <td>
                    {{ laboratory ? '' : 'No'}}

                    <div v-if="laboratory">
                      <small style="font-size: 13px;">
                        <ul
                          v-for="(item, key) in tests"
                          :key="key"
                        >
                          <li>{{ item }}</li>
                        </ul>
                      </small>

                      <div style="margin-top: 15px;" v-if="tests.includes('Others')">
                        <hr />
                        <p>&nbsp;</p>
                        <span style="font-size: 15px; font-weight: bold;">Other Tests:</span>
                        <p style="font-size: 13px;" v-if="other_tests && (typeof other_tests === 'string' || other_tests instanceof String)"><i>{{ other_tests }}</i></p>
                      </div>
                    </div>

                  </td>
                  <td>
                    <div style="font-size: 13px;" v-if="certificate">
                      <strong>Rest days:</strong> {{rest_days}}<br />
                      <strong>Remarks:</strong><br />{{certificate_remark}}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div v-if="consultation">
              <!-- <div v-if="!consultation.requests">
                <span style="color: red;">There is no generated document associated to this submission</span>
              </div> -->
            </div>
          </v-row>

          <!-- ************************************************************* REQUEST ************************************************************* -->

        </v-card-text>
        
        <v-card-actions class="d-flex justify-center" id="bottom-finalize-actions">

            <!-- error message -->
            <div v-if="checkboxError" class="red--text text-center d-block py-3 pr-10">
              Please check all checkboxes to proceed.
            </div>

          <br>

          <v-btn
            rounded
            depressed
            color="primary"
            width="100px"
            @click="finalize()"
            :loading="isSaving"
          >
            SUBMIT
          </v-btn>

          <v-btn
            rounded
            depressed
            color="grey"
            dark
            width="100px"
            @click="summaryDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <base-confirmation-dialog
      v-model="confirmSaveDialog"
      message="All inputs will be saved. Would you like to continue?"
      @confirm="save()"
      @cancel="cancelSave"
    ></base-confirmation-dialog>

    <!-- ****************************************************** SECTION SEPARATOR ****************************************************** -->

    <v-dialog
      v-model="saveSuccessDialog"
      max-width="400px"
      persistent
    >
      <v-card
        class="px-5 py-10"
        rounded="lg"
      >
        <v-card-text>
          <slot>
            <h2 class="text-center">
              Success! Data is saved in patient and case information.
            </h2>
          </slot>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Confirm Btn -->
          <v-btn
            rounded
            depressed
            color="primary"
            width="100px"
            class="mx-3"
            @click="$router.go()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ****************************************************** SECTION SEPARATOR ****************************************************** -->
    
    <v-dialog
      v-model="saveErrorDialog"
      max-width="400px"
      persistent
    >
      <v-card
        class="px-5 py-10"
        rounded="lg"
      >
        <v-card-text>
          <slot>
            <h2 class="text-center">
              <!-- Failed to save all data. Please try again. -->
              {{ failedMessage }}
            </h2>
          </slot>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Confirm Btn -->
          <v-btn
            rounded
            depressed
            color="primary"
            width="100px"
            class="mx-3"
            @click="saveErrorDialog = false;"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ****************************************************** SECTION SEPARATOR ****************************************************** -->


    <v-dialog v-model="hasPMSError" max-width="600px" persistent>
      <v-card class="px-5 py-10" rounded="lg">
        <center><h2>PMS Sync Error</h2></center>
        <hr>
        <table class="mt-5 notes-customized">
          <thead>
            <tr>
              <th align="left" style="width: 50%">Operation</th>
              <th align="left" style="width: 50%">Error</th>
            </tr>
          </thead>
          <tbody v-if="pms_sync_errors.length">
            <tr v-for="(error_instance, key) in pms_sync_errors" :key="key">
              <td align="left" style="width: 50%">{{ error_instance.key }}</td>
              <td align="left" style="width: 50%">{{ error_instance.error.Status }}</td>
            </tr>
          </tbody>
        </table>
        <v-card-actions class="d-flex justify-center">
          <v-btn rounded depressed color="primary" width="100px" class="mx-3" @click="hasPMSError = false;">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ****************************************************** SECTION SEPARATOR ****************************************************** -->

    <v-dialog v-model="nextFormNotesErrorDialog" max-width="400px" persistent>
      <v-card class="px-5 py-10" rounded="lg">
        <v-card-text>
          <slot>
            <h2 class="text-center">
              {{ nextFormErrorMessage }}
            </h2>
          </slot>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Confirm Btn -->
          <v-btn rounded depressed color="primary" width="100px" class="mx-3" @click="nextFormNotesErrorDialog = false;">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MedOpsPrefill />
    <TextReplacementHint />
  </v-container>
</template>

<script>
  import { GET_TEMPLATES } from '../Widgets/typeDefs/MedOpsTemplate';
  export default {
    name: 'Main',

    components: {
      NoCaseSelected: () => import('./components/NoCaseSelected.vue'),
      Sidebar: () => import('./components/Sidebar.vue'),
      ProgressBar: () => import('./components/ProgressBar.vue'),  
      PatientProfile: () => import('@/components/PatientProfile.vue'),
      FormCaseInfo: () => import('./components/form/CaseInfo.vue'),
      FormPatientInfo: () => import('./components/form/PatientInfo.vue'),
      FormExamination: () => import('./components/form/Examination.vue'),
      FormDiagnosis: () => import('./components/form/Diagnosis.vue'),
      FormMedication: () => import('./components/form/Medication.vue'),
      FormNotes: () => import('./components/form/Notes.vue'),
      FormCaseSummary: () => import('./components/form/CaseSummary.vue'),
      MedOpsPrefill: () => import('../Widgets/MedOpsPrefill.vue'),
      TextReplacementHint: () => import('../Widgets/TextReplacementHint.vue')
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    data: ()=>({
      hasPMSError: null,
      pms_sync_errors: [],
      checkboxes: ['case', 'patient', 'exam', 'diagnosis', 'medic', 'recommend', 'note', 'request'],
      errorMessages: [],
      closeCase: false,
      caseStatus: null,
      nextFormErrorMessage: false,
      nextFormNotesErrorDialog: false,
      templateOptions: {},
      validOptionsTitle: [],
      caseStatuses: [
        {
          label: 'Completed',
          value: 'completed'
        },
        {
          label: 'Save Only',
          value: 'ongoing'
        },
        {
          label: 'For Transfer',
          value: 'pending'
        }
      ],
      isSaving: false,
      saveSuccessDialog: false,
      saveErrorDialog: false,
      checkboxError: false,
      confirmSaveDialog: false,
      summaryDialog: false,

      buttons: {
        active: 0,
        list: [
          // case information & history
          { 
            icon:'mdi-note-plus',
            name:"Case Information \n & History",
            id:'caseInfo',
            component: 'form-case-info'
          },
          // patient information
          {
            icon:'mdi-account-circle-outline',
            name:'Patient\n Information',
            id:'patientInfo',
            component: 'form-patient-info'
          },
          // examination
          {
            icon:'mdi-stethoscope',
            name:'Review of Systems',
            id:'examination',
            component: 'form-examination'
          },
          // diagnosis
          {
            icon:'mdi-text-box-search',
            name:'Diagnosis',
            id:'diagnosis',
            component: 'form-diagnosis'
          },
          // medication/recommendation
          { 
            icon:'mdi-pill',
            name:'Medication⁄\n Recommendation',
            id:'medication',
            component: 'form-medication'
          },
          // notes/request
          {
            icon:'mdi-notebook-outline',
            name:'Notes⁄\n Requests',
            id:'notes',
            component: 'form-notes'
          },
          // case summary
          {
            icon:'mdi-clipboard-list',
            name:'Case Summary',
            id:'caseSummary',
            component: 'form-case-summary'
          },
        ]
      },

      pdf: {
        label: 'PDFs',
        value: '',
        send: false
      },
      carePlan: {
        label: 'Care Plan',
        send: false,
        value: ''
      },
      prescriptions: {
        label: 'Prescription',
        send: false,
        sendToMedExpress: false
      },
      laboratoryTest: {
        label: 'Laboratory Test',
        send: false,
      },
      medCertRejected: {
        label: 'Medical Certificate Rejected',
        send: true,
        value: ''
      },
      medCert: {
        label: 'Medical Certificate',
        send: false,
        value: ''
      },
      imageRequest: {
        label: 'Image Request',
        send: false,
        value: ''
      },
      failedMessage: "Failed to save all data. Please try again."
    }),


    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    watch: {
      closeCase(val) {
        if (val) {
          this.caseStatus = null
        }
      },
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    computed: {
      isSeasonalIllness() { return this.$store.getters['cases/isSeasonalIllness'] },
      isGenerated() { return this.$store.getters['request/isGenerated'] },
      patient_email() { return this.$store.getters['patient/fullData'].email },
      destination_email() { return this.$store.getters['request/destination_email'] },
      tests() { return this.$store.getters['request/tests'] },
      other_tests() { return this.$store.getters['request/other_tests'] },
      consultation() { return this.$store.getters['consultation/activeInfo'] },
      terminator() { return this.$store.getters['cases/terminator'] },
      

      medications: {
        get() { return this.$store.getters['medication/medications'] },
        set() { this.$store.getters['medication/medications'] }
      },

      plan() { return this.$store.getters['request/plan'] },
      prescription() { return this.$store.getters['request/prescription'] },
      medex() { return this.$store.getters['request/medex'] },
      certificate() { return this.$store.getters['request/certificate'] },
      laboratory() { return this.$store.getters['request/laboratory'] },
      image() { return this.$store.getters['request/image'] },


      caseFormEmpty() { return this.$store.getters['cases/empty_fields'] },

      /* #################################### METHOD SEPARATOR #################################### */

      formSubmitted: {
        get() { return this.$store.getters['cases/form_submitted'] },
        set(val) { return this.$store.commit('cases/formSubmitted', val) }
      },

      /* #################################### METHOD SEPARATOR #################################### */

      /** current progress by percentage */
      progress() {
        var progress = 0;
        let items = ['case', 'patient', 'examination', 'diagnosis', 'medication', 'recommendation', 'note', 'request'];
        items.forEach(item => {
          progress += this[`${item}Progress`];
        });
          
        return Math.round(progress);
      },

      /* #################################### METHOD SEPARATOR #################################### */

      caseProgress() {
        var items = [], inputs = ['reason', 'category'];
        inputs.forEach(input => items.push(this.$store.getters[`cases/${input}`]) );
        return items.find(item => item !== null || item !== '') ? 10 : 0;
      },

      /* #################################### METHOD SEPARATOR #################################### */

      patientProgress() {
        var items = [], inputs = ['social', 'dietary', 'immunization', 'illness', 'hospitalizations', 'operations'];
        inputs.forEach(input => items.push(this.$store.getters[`patient/${input}`]) );
        return items.find(item => item !== null) ? 18 : 0;
      },

      /* #################################### METHOD SEPARATOR #################################### */

      examinationProgress() {
        var items = [], inputs = ['consti', 'head', 'eyes', 'ears', 'nose', 'cardiovascular', 'respiratory', 'gastrointestinal', 'genitourinary', 'integumentary', 'musculoskeletal', 'neurologic', 'psychiatric'];
        inputs.forEach(input => {
          var active = this.$store.getters[`examination/${input}`]
          if (active) {
            items.push(input)
          }
        });

        var total = 0, input_items;
        items.forEach(item => {
          input_items = this.$store.getters[`examination/${item}_items`]
          if (input_items.length) {
            total++
          }
        });
        return items.length == total ? 24 : 0;
      },

      /* #################################### METHOD SEPARATOR #################################### */

      diagnosisProgress() { return this.$store.getters[`diagnosis/diagnoses`].length > 0 ? 8 : 0 },
      medicationProgress() { return this.$store.getters[`medication/medications`].length > 0 ? 10 : 0 },
      recommendationProgress() { return this.$store.getters[`recommendation/recommendations`].length > 0 ? 6 : 0 },
      noteProgress() { return this.$store.getters[`note/notes`].length > 0 ? 4 : 0 },
      requestProgress() {
        // pdf (5%) care plan (3%) prescriptions (3%) lab (3%) med cert (3%) imageRequest (3%)
        var progress = 0;
        return progress;
      },


      /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

      /** current case chosen */
      activeCase() { 
        return {
          index : this.$store.getters['consultation/activeIndex'],
          list : this.$store.getters['consultation/consultations'],
          filteredList: this.$store.getters['consultation/consultations'].filter(item => item.status == 'ongoing')
        }
      },

      /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

      summary() { 
        console.log({ note: this.$store.getters['note/notes'] })
        console.log("diagnoses in summary")
        console.log(this.$store.getters['diagnosis/diagnoses'])
        
        return {
          reason                    : this.$store.getters['cases/reason'],
          category                  : this.$store.getters['cases/case_category'],
          caseCategoryComments      : this.$store.getters['cases/caseCategoryComments'],
          pediatric_category        : this.$store.getters['cases/case_sub_category'],
          social                    : this.$store.getters['patient/vices'],
          dietary                   : this.$store.getters['patient/dietary'],
          immunization              : this.$store.getters['patient/immunization'],
          illnesses                 : this.$store.getters['patient/illnesses'],
          hospitalizations          : this.$store.getters['patient/hospitalizations'],
          operations                : this.$store.getters['patient/operations'],
          diagnoses                 : this.$store.getters['diagnosis/diagnoses'],
          medications               : this.$store.getters['medication/medications'],
          recommendations           : this.$store.getters['recommendation/recommendations'],
          notes                     : this.$store.getters['cases/notes'],
          case_info                 : this.$store.getters['cases/case']
        }
      },

      patient: function() { return this.$store.getters['patient/fullData'] },
      



      /* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% EXAMINATION DATA %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */

        /* ############################# ACTIVE EXAMINATION ############################# */

        store_constitutional()          { return this.$store.getters['examination/constitutional'] },
        store_head()                    { return this.$store.getters['examination/head'] },
        store_eyes()                    { return this.$store.getters['examination/eyes'] },
        
        store_ears_nose_mouth_throat()  { return this.$store.getters['examination/ears_nose_mouth_throat'] },
        store_cardiovascular()          { return this.$store.getters['examination/cardiovascular'] },
        store_respiratory()             { return this.$store.getters['examination/respiratory'] },
        
        store_gastrointestinal()        { return this.$store.getters['examination/gastrointestinal'] },
        store_genitourinary()           { return this.$store.getters['examination/genitourinary'] },
        store_integumentary()           { return this.$store.getters['examination/integumentary'] },
        
        store_musculoskeletal()         { return this.$store.getters['examination/musculoskeletal'] },
        store_neurologic()              { return this.$store.getters['examination/neurologic'] },
        
        store_psychiatric()             { return this.$store.getters['examination/psychiatric'] },
        store_hema_lymph_immunologic()  { return this.$store.getters['examination/hema_lymph_immunologic'] },

        /* ############################# ACTIVE EXAMINATION ############################# */



        
        /* ############################# EXAMINATION REMARK ############################# */
        
        store_constitutional_note()           { return this.$store.getters['examination/constitutional_note'] },
        store_head_note()                     { return this.$store.getters['examination/head_note'] },
        store_eyes_note()                     { return this.$store.getters['examination/eyes_note'] },
        
        store_ears_nose_mouth_throat_note()   { return this.$store.getters['examination/ears_nose_mouth_throat_note'] },
        store_cardiovascular_note()           { return this.$store.getters['examination/cardiovascular_note'] },
        store_respiratory_note()              { return this.$store.getters['examination/respiratory_note'] },
        
        store_gastrointestinal_note()         { return this.$store.getters['examination/gastrointestinal_note'] },
        store_genitourinary_note()            { return this.$store.getters['examination/genitourinary_note'] },
        store_integumentary_note()            { return this.$store.getters['examination/integumentary_note'] },
        
        store_musculoskeletal_note()          { return this.$store.getters['examination/musculoskeletal_note'] },
        store_neurologic_note()               { return this.$store.getters['examination/neurologic_note'] },
        
        store_psychiatric_note()              { return this.$store.getters['examination/psychiatric_note'] },
        store_hema_lymph_immunologic_note()   { return this.$store.getters['examination/hema_lymph_immunologic_note'] },

        /* ############################# EXAMINATION REMARK ############################# */




        /* ############################# EXAMINATION ITEMS ############################# */

        store_constitutional_items()            { return this.$store.getters['examination/constitutional_items'] },
        store_head_items()                      { return this.$store.getters['examination/head_items'] },
        store_eyes_items()                      { return this.$store.getters['examination/eyes_items'] },
        store_ears_nose_mouth_throat_items()    { return this.$store.getters['examination/ears_nose_mouth_throat_items'] },
        store_cardiovascular_items()            { return this.$store.getters['examination/cardiovascular_items'] },
        store_respiratory_items()               { return this.$store.getters['examination/respiratory_items'] },
        store_gastrointestinal_items()          { return this.$store.getters['examination/gastrointestinal_items'] },
        store_genitourinary_items()             { return this.$store.getters['examination/genitourinary_items'] },
        store_integumentary_items()             { return this.$store.getters['examination/integumentary_items'] },
        store_musculoskeletal_items()           { return this.$store.getters['examination/musculoskeletal_items'] },
        store_neurologic_items()                { return this.$store.getters['examination/neurologic_items'] },
        store_psychiatric_items()               { return this.$store.getters['examination/psychiatric_items'] },

        store_hema_lymph_immunologic_items()    { return this.$store.getters['examination/hema_lymph_immunologic_items'] },

        /* ############################# EXAMINATION ITEMS ############################# */

        rest_days()  { return this.$store.getters['request/rest_days'] },
        certificate_remark()  { return this.$store.getters['request/certificate_remark'] },

      /* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% EXAMINATION DATA %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */




    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    mounted() {
      console.log("doctor dashboard mounted")
      this.templateOptions = GET_TEMPLATES;
        for (let ii in this.templateOptions) {
            this.validOptionsTitle.push(this.templateOptions[ii].notes.title);
        }
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */
    
    methods: {
      /**
       * scrolls to the specified id of element
       */
      scrollAt(id) {
        this.$vuetify.goTo(id, { 
          container: '#formContainer', 
          offset:-50
        })
      },

      /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

      /**
       * process for when the form container is being scrolled
       */
      scrollListener() { 
        // from container current scroll position
        var scrollHeight = document.getElementById('formContainer').scrollTop
        // form elements
        var sections = document.getElementsByClassName('forms');
        // "margin of error"
        var MOE = sections[0].offsetTop;
        
        sections.forEach((element,index) => {
          var offsetTop = element.offsetTop - MOE
          var offsetBottom = element.offsetHeight
          // if scroll position is greater than to the top position of the element 
          if (scrollHeight > (offsetTop-(offsetBottom/3)) ) {
            this.buttons.active = index;
          }
          return;
        });
      },

      /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

      validateNotes (note) {

        if ( this.validOptionsTitle.indexOf(note.title) < 0 ) {
          return true;
        }

        let message = note.note.replaceAll(' ', '').toLowerCase().replace(/\n|\r|-/g, '');
        if (message.indexOf('enterdatahere') > -1) {
          this.nextFormNotesErrorDialog = true;
          this.nextFormErrorMessage = 'Please update the Notes with the correct details';
          return false;
        } else if (message.match(/[^/0-9A-Za-zñÑ:\n'+/.(),&?-|*!%<>]/) != null) {
          this.nextFormNotesErrorDialog = true;
          this.nextFormErrorMessage = 'Please remove brackets in the notes area';
          return false;
        } 
        // else {
        //   let hasEmptyVal = false;
        //   let noteParts = note.note.split("\n").filter(n => n);
        //   noteParts.map(function(val) {
        //     let checked = val.split(":").map(function(val2) { if (val2.replaceAll(' ', '') != '') {return val2.trim()} }).filter(n => n);
        //     if (checked.length <= 1) {
        //       hasEmptyVal = true;
        //     }
        //   });

        //   if (hasEmptyVal) {
        //     this.nextFormNotesErrorDialog = true;
        //     this.nextFormErrorMessage = 'Please check notes entered values';
        //     return false;
        //   }
        // }
        return true;
        },

      async next() {
        console.log("[medications]", this.medications.length);
        console.log("[prescription]", this.prescription);


        var notes = this.$store.getters['cases/notes'];
        if (notes.length > 0) {
          for (let ni in notes) {
            if (!this.validateNotes(notes[ni])) {
              return false;
            }
          }
        }

        if(this.plan || this.prescription || this.certificate || this.laboratory) {
          if(!this.isGenerated) {
            console.log('Please make sure to generate all your documents prior to submitting your case');
            this.saveErrorDialog = true;
            this.failedMessage = "Please make sure to generate all your documents prior to submitting your case";
            console.log("[saveErrorDialog]", this.saveErrorDialog);
            console.log("[isGenerated]", this.isGenerated);
            return false;
          }
        }

        if(this.medications.length > 0) {
          if(!this.prescription) {
            console.log('Please make sure that you have checked the prescription before you proceed');
            this.saveErrorDialog = true;
            this.failedMessage = "Please make sure that you have checked the prescription before you proceed";
            return false;
          }
        }

        if(this.plan || this.prescription || this.certificate || this.laboratory) {
          if(this.destination_email.length == 0) {
            console.log('Email recipient of the documents was not set');
            this.saveErrorDialog = true;
            this.failedMessage = "Email recipient of the documents was not set";
            return false;
          }
        }

        if (!this.caseFormEmpty && this.examinationProgress !== 0 && this.recommendationProgress !== 0) {
        
          this.buttons.active++;
          // this.summaryDialog = true;
          this.errorMessages = []
        
        } else {

          // pedia
          var pedia = 'Pediatric Category'
          var pedia_index =  this.errorMessages.findIndex(e => e == pedia)
          // case
          var cse = 'Case Category'
          var case_index =  this.errorMessages.findIndex(e => e == cse)
          
          if (this.caseFormEmpty) {
            // requires pedia only
            if (this.caseFormEmpty > 1) {
              if (pedia_index < 0)
                this.errorMessages.push(pedia)
              if (case_index >= 0)
                this.errorMessages.splice(case_index, 1)
            }
            // requires case only
            else {
              console.log('required case', case_index)
              if (pedia_index >= 0)
                this.errorMessages.splice(pedia_index, 1)
              if (case_index < 0)
                this.errorMessages.push(cse)
            }
          } else {
            if (pedia_index >= 0) {
              this.errorMessages.splice(pedia_index, 1)
            }
            if (case_index >= 0) {
              this.errorMessages.splice(case_index, 1)
            }
          }

          var diag = 'At least 1 diagnosis'
          var diag_index =  this.errorMessages.findIndex(e => e == diag)
          if (this.diagnosisProgress == 0) {
            if (diag_index < 0) {
              this.errorMessages.push(diag)
            }
          } else {
            if (diag_index >= 0) {
              this.errorMessages.splice(diag_index, 1)
            }
          }

          let reco = 'At least 1 recommendation'
          let reco_index =  this.errorMessages.findIndex(e => e == reco)
          if (this.recommendationProgress == 0) {
            if (reco_index < 0) {
              this.errorMessages.push(reco)
            }
          } else {
            if (reco_index >= 0) {
              this.errorMessages.splice(reco_index, 1)
            }
          }
        }

        // const medicalCertificate = this.$store.getters['request/certificate']
        // const medicalCertificateRemarks = this.$store.getters['request/certificate_remark']

        // if (medicalCertificate && !medicalCertificateRemarks) {
        //   let message = 'Medical Certificate remark is required'
        //   this.errorMessages.push(message)
        // }

        if (this.errorMessages.length == 0) {
          this.summaryDialog = true;
        }

        console.log(this.diagnosisProgress, 'diagnosis %', this.recommendationProgress, 'recommendation %')
      },

      /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

      async save() {

        this.summaryDialog = true;
        var caseInfo = this.$store.getters['cases/activeInfo'];
        var caseId = this.$store.getters['cases/activeInfo'].id;
        var consultId = this.consultation.id;
        var userId = caseInfo.patient.id;

        try {
          this.isSaving = true

          /* ***************************************************** RETRIEVAL OF ALL VALUES RELATED TO THE CASE ***************************************************** */

          let full_payload = {};
          let examination_data = await this.$store.dispatch('examination/compiled_examination', {case_id: caseId, user_id: userId});
          let diagnoses_data = await this.$store.dispatch('diagnosis/compiled_diagnoses', {case_id: caseId, consult_id: consultId});
          let compiled_recommendations = await this.$store.dispatch('recommendation/compiled_recommendations', {case_id: caseId, consult_id: consultId});
          let compiled_medications = await this.$store.dispatch('medication/compiled_medications', {case_id: caseId, consult_id: consultId});
          let compiled_patient_info = await this.$store.dispatch('patient/compiled_patient_info', userId);

          /* ***************************************************** RETRIEVAL OF ALL VALUES RELATED TO THE CASE ***************************************************** */          



          /* ######################## ASSOCIATIVE VALUES OF CASES ######################## */

          full_payload.examination_data = examination_data;
          full_payload.diagnoses_data = diagnoses_data;
          full_payload.recommendations_data = compiled_recommendations;
          full_payload.medications_data = compiled_medications;
          full_payload.compiled_patient_info = compiled_patient_info;
          full_payload.consultation_id = this.consultation.id;
          
          full_payload.consultation_status = "submitted";

          full_payload.terminator = this.terminator;

            /* @@@@@@@@@@@@@@@@@@@@@@@@@ GENERATION OF PDF AND SENDING IT @@@@@@@@@@@@@@@@@@@@@@@@@ */

              full_payload.request_data               = this.consultation.requests;
              full_payload.sendPdf                    = true;
              full_payload.generatePdf                = true;
              full_payload.destination_email          = this.destination_email;
              full_payload.id                         = consultId;
              full_payload.case_consultation_id       = consultId;
               
              full_payload.send_careplan              = this.plan;
              full_payload.send_prescription          = this.prescription;
              full_payload.send_laboratory            = this.laboratory;
              full_payload.send_medical_certificate   = this.certificate;
              full_payload.has_careplan               = this.plan;
              full_payload.has_prescription           = this.prescription;
              full_payload.has_laboratory             = this.laboratory;
              full_payload.has_medical_certificate    = this.certificate;
              full_payload.image_request              = this.image;
              full_payload.send_to_medexpress         = this.medex;
              full_payload.rest_days                  = this.rest_days;
              full_payload.cert_remark                = this.certificate_remark;
              full_payload.cert_rejected_reason       = this.rejection_reason;
              full_payload.laboratory_tests           = this.tests;
              full_payload.other_tests                = this.other_tests;

            /* @@@@@@@@@@@@@@@@@@@@@@@@@ GENERATION OF PDF AND SENDING IT @@@@@@@@@@@@@@@@@@@@@@@@@ */


          /* ######################## ASSOCIATIVE VALUES OF CASES ######################## */



          console.log(full_payload);
          let submitted_case = await this.$store.dispatch('cases/save', {caseId, full_payload});

          this.hasPMSError = submitted_case[0].has_pms_error;
          if(this.hasPMSError) {
          
            this.pms_sync_errors = submitted_case[1];
            this.isSaving = false;
          
          } else {
            
            this.isSaving = false
            this.saveSuccessDialog = true;
            localStorage.removeItem(caseId+'_history')

          }

        } catch(e) {

          this.failedMessage = "Failed to save all data. Please try again.";

          this.isSaving = false;
          this.saveErrorDialog = true;
          console.log('[error]', e);

        }

        /* ############################# SEPARATOR ############################# */

      },

      /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

      finalize() {
        this.confirmSaveDialog = true;
        this.checkboxError = false;
      },

      /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

/*      confirm(value, id) {
        var index = this.checkboxes.findIndex(i => i == id)
        // checked
        if (value)
          this.checkboxes.splice(index, 1)
        // unchecked
        else
          this.checkboxes.push(id)
      },*/

      /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

      cancelSave() {
        this.buttons.active--;
      },

      /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

      medicalCertificateHaveRemarks(event) {
        if (!event) {
          let message = 'Medical Certificate remark is required'
          if (!this.errorMessages.includes(message)) {
            this.errorMessages.push(message)
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
#formContainer {
  height:60vh
}

#fillable {
  height: 72%;
}

.nav-label {
  font-size: .7em;
}

.forms {
  margin-bottom: 50px;
}

.finalize {
  overflow-x: hidden;

  .caption-text {
    font-size: small;
    text-transform: uppercase;
    color: grey;
  }

  .main-text {
    font-size: medium;
    color: black;
  }

  .head-text {
    font-size: large;
    color: black;
  }

  .section-title {
    font-size: large;
    font-weight: bolder;
    color: black;
  }

  .table-wrapper, table {
    width: 100%;
  }

  th {
    font-size: small;
    text-transform: uppercase;
    color: grey;
  }

  td {
    font-size: medium;
    color: black;
  }

  .medium-shade {
    background: #f6f6f6;
    border-radius: 10px !important;
    padding: 15px !important;
    font-size: 13px;
  }



  .notes-customized {
    padding-bottom: 10px !important;
    width:  100% !important;
  }

  .notes-customized th {
    background: #eee !important;
    color: #258bf5 !important;
    padding: 5px !important;
  }

  .notes-customized tr td { padding: 5px !important; font-size: 12px !important; }

  .notes-customized tr:nth-child(even) td {
    background:  #e6e6e6 !important;
  }

  .notes-customized tr:nth-child(odd) td {
    background:  #f6f6f6 !important;
  }




  .table {
      width: 100%;
      margin-bottom: 1rem;
      color: #212529;
      border-collapse: collapse;
  }
  .table th,
  .table td {
      padding: 0.75rem;
      vertical-align: top;
      border-top: 1px solid #dee2e6;
  }
  .table thead th {
      vertical-align: bottom;
      border-bottom: 2px solid #dee2e6;
  }
  .table tbody + tbody {
      border-top: 2px solid #dee2e6;
  }
  .table-sm th,
  .table-sm td {
      padding: 0.3rem;
  }


  .table-striped tbody tr:nth-of-type(odd) {
      background-color: rgba(0, 0, 0, 0.05);
  }


  .table-bordered {
      border: 1px solid #dee2e6;
  }
  .table-bordered th,
  .table-bordered td {
      border: 1px solid #dee2e6;
  }
  .table-bordered thead th,
  .table-bordered thead td {
      border-bottom-width: 2px;
  }


  .table-borderless th,
  .table-borderless td,
  .table-borderless thead th,
  .table-borderless tbody + tbody {
      border: 0;
  }


  .table-hover tbody tr:hover {
      color: #212529;
      background-color: rgba(0, 0, 0, 0.075);
  }


  .table-primary,
  .table-primary > th,
  .table-primary > td {
      background-color: #b8daff;
  }
  .table-secondary,
  .table-secondary > th,
  .table-secondary > td {
      background-color: #d6d8db;
  }
  .table-success,
  .table-success > th,
  .table-success > td {
      background-color: #c3e6cb;
  }
  .table-danger,
  .table-danger > th,
  .table-danger > td {
      background-color: #f5c6cb;
  }
  .table-warning,
  .table-warning > th,
  .table-warning > td {
      background-color: #ffeeba;
  }
  .table-info,
  .table-info > th,
  .table-info > td {
      background-color: #bee5eb;
  }
  .table-light,
  .table-light > th,
  .table-light > td {
      background-color: #fdfdfe;
  }
  .table-dark,
  .table-dark > th,
  .table-dark > td {
      background-color: #c6c8ca;
  }
}
</style>